<template>
  <section :class="[bem({ fullWidth }), 'global-wrapper-large']">
    <BaseHeading
      v-if="subtitle"
      :class="bem('subtitle')"
      size="h5"
      tag="h5"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="parseText($tr(subtitle))" />
    </BaseHeading>

    <BaseHeading
      :class="bem('heading')"
      :size="largeTitle ? 'h1-lg' : 'h1'"
      :tag="titleTag || 'h2'"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="parseText($tr(title))" />
    </BaseHeading>
  </section>
</template>

<script>
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  name: 'StandFirst',

  mixins: [parseTextMixin],

  props: {
    largeTitle: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: ''
    },

    titleTag: {
      type: String,
      default: 'h2'
    },

    subtitle: {
      type: String,
      default: ''
    },

    fullWidth: {
      type: Boolean,
      default: false
    }
  },

  setup () {
    return {
      bem: useBEM('StandFirst')
    }
  }
}
</script>

<style lang="postcss">
.StandFirst__subtitle {
  @apply mb-xs md:mb-sm
    t-gradient;

  .is-dark-chrome-theme & {
    @apply t-gradient-chrome;
  }

  text-transform: uppercase;
  display: inline-block;
}
</style>
